{% block sw_data_grid_inline_edit_type_unknown %}
<sw-datepicker
    deprecated
    v-else-if="column.inlineEdit === 'date'"
    key="date"
    date-type="date"
    v-model:value="currentValue"
    name="sw-field--currentValue"
/>

<sw-datepicker
    deprecated
    v-else-if="column.inlineEdit === 'datetime'"
    key="datetime"
    date-type="datetime"
    v-model:value="currentValue"
    name="sw-field--currentValue"
/>

{% parent() %}
{% endblock %}